import React from "react";
import Helpful from "../../components/Helpful/Helpful";

const HelpfulPage = () => {
  return <Helpful />;
};

export default HelpfulPage;
